<template>
  <div class="stories-wrapper">
    <div class="close" @click="$router.go(-1)"></div>
    <div class="stories">
      <div
        v-for="(story, index) in stories"
        :key="index"
        class="story"
        :style="
          index === indexSelected
            ? `transform: translate(0px)`
            : `transform: translate(${calculateTransform(
                index
              )}px) scale(0.3);cursor:pointer;`
        "
        @click="index !== indexSelected ? selectSlide(index) : ''"
      >
        <div
          class="story__source"
          @click="playStory1($event)"
          :style="
            getSrc(story, index).background == 'gradient-1'
              ? 'background: linear-gradient(pink, orange);'
              : getSrc(story, index).background == 'gradient-2'
              ? 'background: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%);'
              : getSrc(story, index).background == 'gradient-3'
              ? 'background: linear-gradient(45deg, #FA8BFF 0%, #2BD2FF 52%, #2BFF88 90%);'
              : getSrc(story, index).background == 'gradient-4'
              ? 'background-image: linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%);'
              : getSrc(story, index).background == 'gradient-5'
              ? 'background-image: linear-gradient(0deg, #FFDEE9 0%, #B5FFFC 100%);'
              : getSrc(story, index).background == 'gradient-6'
              ? 'background-image: linear-gradient(19deg, #3EECAC 0%, #EE74E1 100%);'
              : getSrc(story, index).background == 'gradient-7'
              ? 'background-image: linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%);'
              : getSrc(story, index).background == 'gradient-8'
              ? 'background-image: linear-gradient(0deg, #08AEEA 0%, #2AF598 100%);'
              : getSrc(story, index).background == 'gradient-9'
              ? 'border:1px solid gainsboro;background:white;'
              : 'background: #000000'
          "
        >
          <button
            class="active"
            v-show="getSrc(story, index).type === 'video' && hideplaybutton"
          >
            <svg-icon
              name="play"
              style="fill: white; width: 45px; height: 45px"
            />
          </button>
          <loader :show="loadingVideo">
            <template v-for="(idx, name) in $scopedSlots" #[name]="data">
              <slot :name="name" v-bind="data" />
            </template>
          </loader>
          <video
            :id="getSrc(story, index).url"
            ref="video"
            v-if="getSrc(story, index).type === 'video'"
          >
            <source
              :src="`${this.$store.state.endpoints.appUrl}${
                getSrc(story, index).url
              }#t=0.5`"
              type="video/mp4"
            />
            <source
              :src="`${this.$store.state.endpoints.appUrl}${
                getSrc(story, index).url
              }#t=0.5`"
              type="video/ogg"
            />
            <source
              :src="`${this.$store.state.endpoints.appUrl}${
                getSrc(story, index).url
              }#t=0.5`"
              type="video/webm"
            />
            <!-- <div class="playButton" onclick="playPause()"></div> -->
          </video>
          <img
            v-else-if="getSrc(story, index).type === 'image'"
            :src="`${this.$store.state.endpoints.appUrl}${
              getSrc(story, index).url
            }`"
            alt=""
          />
          <div class="slide" v-else>
            <div class="slide-content">
              <p
                :class="
                  getSrc(story, index).background == 'gradient-9'
                    ? 'text-dark'
                    : 'text-white'
                "
                v-html="getSrc(story, index).url"
              ></p>
            </div>
          </div>
          <div class="story__header" v-if="index === indexSelected">
            <div class="time">
              <div
                class="time__item"
                v-for="(elm, index) in story.images.length"
                :key="index"
              >
                <div
                  class="time__fill"
                  :style="
                    index === key
                      ? `width: ${percent}%`
                      : key > index
                      ? `width:100%`
                      : `width:0%`
                  "
                ></div>
              </div>
            </div>
            <div class="story__top">
              <div class="user">
                <div class="user__image">
                  <img
                    :src="`${this.$store.state.endpoints.appUrl}${story.picture}`"
                    alt=""
                  />
                </div>
                <div class="user__name">
                  {{ story.username }}
                </div>
              </div>
            </div>
            <div
              class="story__time"
              v-if="
                getHumanDate1(getSrc(story, index).created_at) ==
                getHumanDate1(new Date())
              "
            >
              Today at {{ getHumanDate(getSrc(story, index).created_at) }}
            </div>
            <div class="story__time" v-else>
              Yesterday at {{ getHumanDate(getSrc(story, index).created_at) }}
            </div>
          </div>

          <div class="story__body">
            <div class="user" v-if="index !== indexSelected">
              <div
                class="user__image"
                :style="
                  getNotViewedIndex(story) === -1 ? `background: #FFFFFF` : ''
                "
              >
                <img
                  :src="`${this.$store.state.endpoints.appUrl}${story.picture}`"
                  alt=""
                />
              </div>
              <div class="user__name">
                {{ story.username }}
              </div>
            </div>
            <slot
              v-if="showInnerContent && index === indexSelected"
              name="innerContent"
              :story="story"
            ></slot>
          </div>
          <div
            style="
              position: absolute;
              bottom: 20px;
              z-index: 9999;
              left: 0;
              right: 0;
            "
            @click="bott(index)"
            v-if="story.userid === authuser.id"
          >
            <div style="display: flex; justify-content: center; width: 100%">
              <span>
                <em
                  style="
                    font-size: 20px;
                    font-style: normal;
                    color: rgb(0, 110, 255);
                    cursor: pointer;
                  "
                ></em
                ><i
                  style="
                    color: rgb(0, 110, 255);
                    font-size: 25px;
                    cursor: pointer;
                  "
                  ><svg-icon name="eye" style="fill: rgb(0, 110, 255)" /></i
                ><em
                  style="
                    font-size: 20px;
                    font-style: normal;
                    color: rgb(0, 110, 255);
                    cursor: pointer;
                  "
                  >{{ getSrc(story, index).viewers.length }}</em
                >
              </span>
            </div>
          </div>
          <div
            style="
              position: absolute;
              bottom: 20px;
              z-index: 9999;
              left: 0;
              right: 0;
            "
            @click="bottReply(index)"
            v-else
          >
            <div style="display: flex; justify-content: center; width: 100%">
              <span>
                <i
                  style="
                    color: rgb(0, 110, 255);
                    font-size: 25px;
                    cursor: pointer;
                  "
                  ><svg-icon
                    name="angle-up"
                    style="fill: rgb(0, 110, 255)" /></i
                ><em
                  style="
                    font-size: 20px;
                    font-style: normal;
                    color: rgb(0, 110, 255);
                    cursor: pointer;
                  "
                  >Reply</em
                >
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="index === indexSelected"
          class="story__icon story__icon--prev"
          @click="reset(), prev(index)"
        ></div>
        <div
          v-if="index === indexSelected"
          class="story__icon story__icon--next"
          @click="reset(), next(index)"
        ></div>
        <slot
          v-if="showOuterContent && index === indexSelected"
          name="outerContent"
          :story="story"
        ></slot>
        <vue-bottom-sheet
          :title="`Seen by`"
          ref="myBottomSheet"
          height="768px"
          @opened="open(getSrc(story, index).url)"
          @closed="close(getSrc(story, index).url)"
          :click-to-close="false"
          :background-clickable="true"
        >
          <ul
            class="media-story m-0 p-0"
            style="max-height: 768px; overlow-y: scroll; margin: 0; padding: 0"
          >
            <li
              style="display: flex; margin-bottom: 20px; align-items: center"
              class="d-flex mb-4"
              v-for="(event, index) in getSrc(story, index).viewers"
              :key="index"
            >
              <img
                :src="`${this.$store.state.endpoints.appUrl}${event.user.image}`"
                alt="story-img"
                style="width: 35px; height: 35px; border-radius: 25px"
                class="avatar-35 rounded-circle img-fluid"
              />

              <div class="stories-data ml-3" style="margin-left: 15px">
                <h5>{{ event.user.username }}&nbsp;</h5>
                <p
                  v-if="
                    getHumanDate1(event.created_at) == getHumanDate1(new Date())
                  "
                >
                  Today at {{ getHumanDate(event.created_at) }}
                </p>
                <p v-else>Yesterday at {{ getHumanDate(event.created_at) }}</p>
              </div>
            </li>
          </ul>
        </vue-bottom-sheet>
        <vue-bottom-sheet
          :title="`Seen by`"
          ref="myBottomSheetReply"
          height="768px"
          @opened="openReply(getSrc(story, index).url)"
          @closed="closeReply(getSrc(story, index).url)"
          :click-to-close="false"
          :background-clickable="true"
          @click="openReply(getSrc(story, index).url)"
        >
          <div class="comment-on-story">
            <div class="profile-image">
              <img
                :src="`${this.$store.state.endpoints.appUrl}${authuser.image}`"
                alt=""
              />
            </div>
            <div class="input-comment">
              <textarea
                name=""
                class="comment-control"
                cols="20"
                rows="10"
                placeholder="Write a comment..."
                v-model="text"
              ></textarea>
            </div>
            <span
              @click="
                replystatus(
                  story.userid,
                  story.username,
                  story.picture,
                  getSrc(story, index).text,
                  getSrc(story, index).attachment,
                  getSrc(story, index).type
                )
              "
            >
              <i><svg-icon name="message" style="fill: rgb(0, 110, 255)" /></i>
            </span>
          </div>
        </vue-bottom-sheet>
      </div>
    </div>
  </div>
</template>

<script>
import { IonContent, IonPage } from "@ionic/vue";
import VueBottomSheet from "../vue-bottom-sheet";
import Loader from "../Loader/Loader1.vue";
import SvgIcon from "../SvgIcon.vue";
import moment from "moment";
import Hammer from "hammerjs";

export default {
  name: "Stories",
  components: {
    SvgIcon,
    Loader,
    VueBottomSheet,
    IonContent,
    IonPage,
  },
  props: {
    stories: {
      type: Array,
      required: true,
    },
    duration: {
      type: Number,
      default: 7000,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    showInnerContent: {
      type: Boolean,
      default: false,
    },
    showOuterContent: {
      type: Boolean,
      default: false,
    },
    authuser: {},
  },

  data: () => ({
    loadingVideo: false,
    hideplaybutton: true,
    text: "",
    indexSelected: 0,
    difference: 0,
    key: 0,
    percent: 0,
    timer: 0,
    progress: 0,
    interval: 0,
    isPaused: false,
    newDur: 0,
    pausePer: 0,
  }),
  computed: {
    isAllStoriesEnd() {
      return (
        this.indexSelected >= this.stories.length - 1 &&
        this.isCurrentAllImagesEnd
      );
    },
    isCurrentAllImagesEnd() {
      return this.key >= this.stories[this.indexSelected].images.length - 1;
    },
  },
  methods: {
    pl() {
      this.isPaused = true;
      this.pausePer = this.percent;
      clearInterval(this.progress);
      clearInterval(this.interval);
    },
    getHumanDate1: function (date) {
      return moment(String(date)).format("DD/MM/YYYY");
    },
    getHumanDate: function (date) {
      return moment(String(date)).format("LT");
    },
    replystatus(
      receiver_id,
      username,
      userimage,
      statustext,
      messageFile,
      messageType
    ) {
      axios
        .post(
          "/statusreply",
          {
            contact_id: receiver_id,
            text: this.text,
            user_id: receiver_id,
            user_name: username,
            user_image: userimage,
            texting: statustext,
            messageFile: messageFile,
            messageType,
          },
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } }
        )
        .then((response) => {});
      this.text = "";
      // this.isPaused = false;
      // this.play();
      // this.$refs.myBottomSheetReply[index].close();
    },
    bottReply(index) {
      this.$refs.myBottomSheetReply[index].open();
      this.isPaused = true;
      this.pausePer = this.percent;
      clearInterval(this.progress);
      clearInterval(this.interval);
      this.newDur = this.duration - (this.pausePer * this.duration) / 100;
    },
    openReply(id) {
      const video = document.getElementById(id);
      if (video) {
        video.pause();
      }
      this.isPaused = true;
      this.pausePer = this.percent;
      // clearInterval(this.progress);
      // clearInterval(this.interval);
      this.newDur = this.duration - (this.pausePer * this.duration) / 100;
    },
    closeReply(id) {
      const video = document.getElementById(id);
      if (video) {
        video.play();
      }
      this.isPaused = false;
      if (this.stories[this.indexSelected].images[this.key].type === "video") {
        this.play();
      } else {
        this.play1();
      }
    },
    bott(index) {
      this.$refs.myBottomSheet[index].open();
    },
    open(id) {
      const video = document.getElementById(id);
      if (video) {
        video.pause();
      }
      this.isPaused = true;
      this.pausePer = this.percent;
      clearInterval(this.progress);
      clearInterval(this.interval);
      this.newDur = this.duration - (this.pausePer * this.duration) / 100;
    },
    close(id) {
      const video = document.getElementById(id);
      if (video) {
        video.play();
      }
      this.isPaused = false;
      this.play();
    },
    getSrc(story, index) {
      const viewedIndex = this.getLastViewedIndex(story);
      return index === this.indexSelected
        ? {
            url: story.images[this.key].url,
            type: story.images[this.key].type,
            background: story.images[this.key].background,
            viewers: story.images[this.key].viewers,
            text: story.images[this.key].text,
            attachment: story.images[this.key].attachment,
            created_at: story.images[this.key].created_at,
          }
        : {
            url: story.images[viewedIndex].url,
            type: story.images[viewedIndex].type,
            background: story.images[viewedIndex].background,
            viewers: story.images[viewedIndex].viewers,
            text: story.images[viewedIndex].text,
            attachment: story.images[viewedIndex].attachment,
            created_at: story.images[viewedIndex].created_at,
          };
    },
    getNotViewedIndex(story) {
      return story.images.findIndex((item) => !item.viewed);
    },
    getLastViewedIndex(story) {
      const keyIndex = this.getNotViewedIndex(story);

      const index = story.images.length - 1;

      return keyIndex === -1 ? index : keyIndex;
    },
    selectSlide(index) {
      // this.isPaused = true;
      this.difference += this.indexSelected - index;
      // this.duration = 7000
      // this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      this.indexSelected = index;
      this.key = this.getLastViewedIndex(this.stories[this.indexSelected]);
      this.reset();
    },
    onAllStoriesEnd() {
      this.difference = 0;
      this.indexSelected = 0;
      this.key = 0;
      // this.$emit('allStoriesEnd');
    },
    onCurrentAllImagesEnd(index) {
      this.difference += index - (index + 1);
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      this.stories[index].images[this.key].viewed = true;
      this.hideplaybutton = true;
      //  this.duration = 7000
      this.indexSelected++;
      this.key = this.getLastViewedIndex(this.stories[this.indexSelected]);
      this.$emit("сurrentAllImagesEnd", index);

      // this.$router.replace('/stories/reads')
    },
    onCurrentImageEnd(index) {
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      this.hideplaybutton = true;
      // this.duration = 7000
      // this.duration = this.stories[index].images[this.key].duration
      this.stories[index].images[this.key].viewed = true;
      // this.$store.state.stores[index].images[this.key].viewed = true
      this.$emit("сurrentImageEnd", this.key);
      this.key++;
    },
    next(index) {
      this.hideplaybutton = true;
      this.isPaused = false;
      // clearInterval(this.progress);
      // clearInterval(this.interval);
      // this.newDur = this.duration - (this.pausePer * this.duration) / 100;
      if (this.isAllStoriesEnd) {
        this.onAllStoriesEnd();
      } else if (this.isCurrentAllImagesEnd) {
        setTimeout(() => {
          this.onCurrentAllImagesEnd(index);
        });
      } else {
        this.stories[index].images[this.key].viewed = true;
        this.key++;
        //  this.duration = 7000
        //this.duration = this.stories[index].images[this.key].duration
      }
      this.reset();
    },
    prev(index) {
      // this.duration = 7000
      this.hideplaybutton = true;
      // this.duration = this.stories[this.indexSelected - 1].images[this.key].duration
      this.isPaused = false;
      // clearInterval(this.progress);
      // clearInterval(this.interval);
      // this.newDur = this.duration - (this.pausePer * this.duration) / 100;
      if (this.indexSelected <= 0 && this.key <= 0) {
        this.key = 0;
      } else if (this.key <= 0) {
        // Without delay
        setTimeout(() => {
          this.difference += index - (index - 1);
          this.indexSelected--;
          this.key = this.getLastViewedIndex(this.stories[this.indexSelected]);
        });
      } else {
        this.key--;
        this.stories[index].images[this.key].viewed = false;
      }
      this.reset();
    },
    autoPlay() {
      if (this.isAllStoriesEnd) {
        this.onAllStoriesEnd();
        this.$store.dispatch("stories");
        this.$router.go(-1);
      } else if (this.isCurrentAllImagesEnd) {
        this.onCurrentAllImagesEnd(this.indexSelected);
        this.$store.dispatch("stories");
      } else {
        this.onCurrentImageEnd(this.indexSelected);
        this.$store.dispatch("stories");
      }
      this.reset();
    },
    play1() {
      // this.duration = this.stories[this.indexSelected].images[this.key].duration
      this.timer = new Date().getTime();
      this.progress = setInterval(() => {
        let time = new Date().getTime();
        if (this.newDur > 0) {
          this.percent =
            this.pausePer +
            Math.floor((100 * (time - this.timer)) / this.duration);
        } else {
          this.percent = Math.floor(
            (100 * (time - this.timer)) /
              this.stories[this.indexSelected].images[this.key].duration
          );
        }
      }, this.duration / 100);

      if (this.newDur > 0) {
        this.interval = setInterval(this.autoPlay, this.newDur);
      } else {
        this.interval = setInterval(this.autoPlay, this.duration);
      }
      axios.post(
        `${this.$store.state.endpoints.newVisto}`,
        { story_id: this.stories[this.indexSelected].images[this.key].id },
        { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
      );
      this.stories[this.indexSelected].images[this.key].viewed = true;
    },
    play() {
      // this.duration = this.stories[this.indexSelected].images[this.key].duration
      this.timer = new Date().getTime();
      this.progress = setInterval(() => {
        // forward
        let time = new Date().getTime();
        if (this.newDur > 0) {
          this.percent =
            this.pausePer +
            Math.floor((100 * (time - this.timer)) / this.duration);
        } else {
          this.percent = Math.floor(
            (100 * (time - this.timer)) /
              this.stories[this.indexSelected].images[this.key].duration
          );
        }
      }, this.duration / 100);
      if (this.stories[this.indexSelected].images[this.key].type === "video") {
        clearInterval(this.interval);
        clearInterval(this.progress);
        // this.playStory1($event)

        // this.duration = this.stories[this.indexSelected].images[this.key].duration
      } else if (this.newDur > 0) {
        this.interval = setInterval(this.autoPlay, this.newDur);
      } else {
        this.interval = setInterval(this.autoPlay, this.duration);
      }
      axios.post(
        `${this.$store.state.endpoints.newVisto}`,
        { story_id: this.stories[this.indexSelected].images[this.key].id },
        { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
      );
      this.stories[this.indexSelected].images[this.key].viewed = true;
    },
    reset() {
      this.percent = 0;
      clearInterval(this.interval);
      clearInterval(this.progress);
      this.newDur = 0;
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      if (this.stories[this.indexSelected].images[this.key].type === "video") {
        this.play();
      } else {
        this.play1();
      }
    },
    pauseStory(event) {
      if (event) {
        this.toggleVideo("pause", event);
      }
      this.isPaused = true;
      this.pausePer = this.percent;
      clearInterval(this.progress);
      clearInterval(this.interval);
      this.newDur = this.duration - (this.pausePer * this.duration) / 100;
    },
    playStory(event) {
      if (event) {
        this.toggleVideo("play", event);
      }

      this.isPaused = false;
      this.play();
      this.hideplaybutton = false;
    },
    playS(event) {
      alert("play video");
    },
    playStory1(event) {
      if (event) {
        this.toggleVideo("play", event);
        this.hideplaybutton = false;
      }
    },
    toggleVideo(type, event) {
      const video = document.getElementById(event.target.id);
      if (video) {
        video[type]();
        var self = this;
        video.addEventListener("ended", function () {
          // alert('video has ended')
          self.reset();
          self.next(self.currentIndex);
          //  self.play1()
        });
        video.addEventListener("waiting", function () {
          // alert('waiting now')
          self.loadingVideo = true;
          self.isPaused = true;
          self.pausePer = self.percent;
          clearInterval(self.progress);
          clearInterval(self.interval);
          // self.newDur = self.duration - (self.pausePer * self.duration) / 100;
        });

        video.addEventListener("playing", function () {
          // alert('playing now')
          if (video.readyState == 4) {
            self.loadingVideo = false;
            self.duration =
              self.stories[self.indexSelected].images[self.key].duration;
            self.isPaused = false;
            clearInterval(self.progress);
            clearInterval(self.interval);
            self.newDur = self.duration - (self.pausePer * self.duration) / 100;
            self.play();
          } else {
            self.loadingVideo = true;
            self.isPaused = true;
            self.pausePer = self.percent;
            clearInterval(self.progress);
            clearInterval(self.interval);
            self.newDur = self.duration - (self.pausePer * self.duration) / 100;
          }
        });

        video.addEventListener("suspend", function () {
          // alert('playing now')
          if (video.readyState == 4) {
            self.loadingVideo = false;
            self.isPaused = false;
            clearInterval(self.progress);
            clearInterval(self.interval);
            self.newDur = self.duration - (self.pausePer * self.duration) / 100;
            self.play();
          } else {
            self.loadingVideo = true;
            self.isPaused = true;
            self.pausePer = self.percent;
            clearInterval(self.progress);
            clearInterval(self.interval);
            self.newDur = self.duration - (self.pausePer * self.duration) / 100;
          }
        });
      }
    },
    unMuteVideo(id) {
      const video = document.getElementById(id);
      if (video) {
        video.muted = !video.muted;
        video.currentTime = 0;
      }
    },
    unMuteVideo1(id) {
      const video = document.getElementById(id);
      if (video) {
        video.muted = true;
        video.currentTime = 0;
      }
    },
    stopVideo(id) {
      const video = document.getElementById(id);
      if (video) {
        video.pause();
        //  video.muted = true
        video.currentTime = 0;
      }
    },
    calculateTransform(index) {
      if (
        this.indexSelected - index === -1 ||
        this.indexSelected - index === 1
      ) {
        return 315 * (index + this.difference);
      }
      if (index > this.indexSelected) {
        return (315 + 315 * (index + this.difference)) * 0.5;
      } else {
        return Math.abs((315 - 315 * (index + this.difference)) * 0.5) * -1;
      }
    },
    closeStories() {
      // this.$emit('closeStories');
    },
  },
  beforeUnmount() {
    clearInterval(this.progress);
    clearInterval(this.interval);
  },
  mounted() {
    let $timeline = this.$el.getElementsByClassName("stories")[0];
    // this.play();
    this.selectSlide(this.currentIndex);
    this.hammer = new Hammer.Manager(this.$el, {
      recognizers: [
        [Hammer.Pan, { direction: Hammer.DIRECTION_HORIZONTAL }],
        [Hammer.Tap],
        [Hammer.Press, { time: 1, threshold: 1000000 }],
      ],
    });

    this.hammer.on("press", () => {
      // this.timeline.pause();
      this.pauseStory();
    });

    this.hammer.on("pressup tap", () => {
      // this.timeline.play();
      this.playStory();
    });

    // Tap on the side to navigate between slides
    this.hammer.on("tap", (event) => {
      if (event.center.x > window.innerWidth / 3) {
        // this.nextSlide();
        // this.next(this.indexSelected)
      } else {
        // this.previousSlide();
      }
    });

    // Handle swipe
    this.hammer.on("pan", (event) => {
      if (event.isFinal) {
        if (event.deltaX < 0) {
          // this.nextStory();
          this.reset();
          this.next(this.currentIndex);
        } else if (event.deltaX > 0) {
          // this.previousStory();
          this.reset();
          this.prev(this.currentIndex);
        }
      }
    });

    const text = document.querySelectorAll(".slide-content p");

    text.forEach((item) => {
      const textLength = item.innerText.length;
      console.log(textLength);
      if (textLength > 50 && textLength < 300) {
        item.style.fontSize = "25px";
        item.style.lineHeight = "40px";
      } else if (textLength > 300) {
        item.style.fontSize = "12px";
        item.style.lineHeight = "30px";
      } else if (window.innerWidth < 600 && textLength < 300) {
        item.style.fontSize = "25px";
        item.style.lineHeight = "auto";
      }
    });
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.stories-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(16, 16, 16, 0.98);
  font-family: sans-serif;
}

.stories {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.story {
  position: absolute;
  transition: transform 0.2s cubic-bezier(0.4, 0, 1, 1);
  // width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__source {
    position: relative;
    border-radius: 16px;
    // background: #000000;
    width: 414px;
    height: 751px;
    background-size: contain;

    @media screen and (max-width: 768px) {
      width: 100%;
      height: auto;
      flex: 1 1 auto;
    }

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }

    .slide {
      /* Take the rest of the page */
      margin-top: 100px;
      margin-bottom: 100px;
      /* Center align */
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .slide .slide-content {
      width: 500px;
      text-align: center;
      // margin-top:-5%;
      color: lightgray;
      position: relative;
      margin: 0;
      text-align: center;
      overflow-wrap: break-word;
      overflow: hidden;
      font-weight: bold;

      max-height: 398px;
    }
    .slide p {
      font-size: 60px;
      color: #fff;
      line-height: 60px;
    }

    // @media(max-width:600px){
    //   .slide .slide-content{
    //       width:90%;
    //   }
    //   .slide p {
    //      font-size:24px !important;
    //      line-height:30px !important;
    //   }
    // }
    // @media(max-width:450px){
    //    .slide p{
    //      font-size:15px !important;
    //      line-height:25px !important;
    //    }
    // }
  }

  &__header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 8px 11px;
  }

  &__time {
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
    margin-left: 40px;
  }

  &__top {
    display: flex;
    align-items: center;
  }

  &__body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    .user {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    .user__name {
      display: none;
    }

    .user__image {
      width: 140px;
      height: 140px;
      background: linear-gradient(180deg, #4c7cf6 0%, #6200c3 100%);
      margin: 0;
      padding: 5px;

      img {
        border: 5px solid #ffffff;
        border-radius: 100%;
      }
    }
  }

  &__icon {
    width: 24px;
    height: 24px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    @media screen and (max-width: 768px) {
      top: 0;
      bottom: 0;
      transform: none;
      width: 100px;
      height: auto;
      background: none;
    }

    &:before {
      content: "";
      position: absolute;
      top: 8px;
      left: 9px;
      border: solid #323232;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(135deg);
      border-radius: 1px;

      @media screen and (max-width: 768px) {
        content: none;
      }
    }

    &--prev {
      left: -35px;

      @media screen and (max-width: 768px) {
        left: 0;
      }
    }

    &--next {
      right: -35px;
      transform: translateY(-50%) rotate(180deg);

      @media screen and (max-width: 768px) {
        right: 0;
        transform: none;
      }
    }
  }
}

.user {
  display: flex;
  align-items: center;

  &__image {
    width: 32px;
    height: 32px;
    border-radius: 100px;
    overflow: hidden;
    margin-right: 8px;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  &__name {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #ffffff;
    margin-right: 5px;
  }
}

.time {
  display: flex;
  margin-bottom: 10px;

  &__item {
    position: relative;
    width: 100%;
    height: 2px;
    margin-right: 4px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 4px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__fill {
    position: absolute;
    width: 100%;
    background: #ffffff;
    height: 2px;
  }
}

.close {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;

  &:after {
    content: "\00d7";
    color: #ffffff;
    font-weight: 100;
    font-size: 35px;
    z-index: 9999;
  }

  .gradient-0 {
    background: #000000;
  }
  .gradient-1 {
    background: linear-gradient(pink, orange);
  }

  .gradient-2 {
    background: linear-gradient(19deg, #21d4fd 0%, #b721ff 100%);
  }

  .gradient-3 {
    background: linear-gradient(45deg, #fa8bff 0%, #2bd2ff 52%, #2bff88 90%);
  }

  .gradient-4 {
    background-image: linear-gradient(
      90deg,
      #ff9a8b 0%,
      #ff6a88 55%,
      #ff99ac 100%
    );
  }

  .gradient-5 {
    background-image: linear-gradient(0deg, #ffdee9 0%, #b5fffc 100%);
  }

  .gradient-6 {
    background-image: linear-gradient(19deg, #3eecac 0%, #ee74e1 100%);
  }

  .gradient-7 {
    background-image: linear-gradient(
      225deg,
      #ff3cac 0%,
      #784ba0 50%,
      #2b86c5 100%
    );
  }

  .gradient-8 {
    background-image: linear-gradient(0deg, #08aeea 0%, #2af598 100%);
  }

  .gradient-9 {
    border: 1px solid gainsboro;
    background: white;
  }
}

.profile-image {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}

img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.comment-on-story {
  display: flex;
  width: 400px;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem auto;
}
.comment-on-story .profile-image {
  width: 30px;
  height: 30px;
}
.input-comment {
  width: 85%;
}
.input-comment .comment-control {
  height: 40px;
  width: 100%;
  padding: 0.5rem;
  font-family: "Quicksand";
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  background-color: rgb(240, 240, 240);
  border: none;
  outline: none;
  resize: none;
  color: #333;
}
.comment-control::placeholder {
  font-size: 0.8rem;
}
.comment-on-story span {
  font-size: 30px;
  color: rgb(21, 31, 43);
  cursor: pointer;
}

@media (max-width: 420px) {
  .comment-on-story {
    width: 90%;
  }
}
.general {
  position: relative;
}
.playButton {
  // border-radius: 90px;
  // border: 12px solid #fff;
  // height: 100px;
  position: absolute;
  // width: 100px;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  cursor: pointer;
}
.playButton:before {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 25px 0 25px 50px;
  border-color: transparent transparent transparent #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: -10px;
  bottom: 0;
  margin: auto;
}
// video {
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   min-width: 100%;
//   min-height: 100%;
//   z-index: -1;
//   -webkit-transition: all 1s;
//   -moz-transition: all 1s;
//   -o-transition: all 1s;
//   transition: all 1s;
// }
button {
  background: transparent;
  border: medium none;
  display: flex;
  font-size: 18px;
  left: 0;
  margin: 0 auto;
  padding: 8px 16px;
  position: absolute;
  right: 0;
  top: 50%;
  justify-content: center;
}

.round-button {
  box-sizing: border-box;
  display: block;
  width: 80px;
  height: 80px;
  padding-top: 14px;
  padding-left: 8px;
  line-height: 20px;
  border: 6px solid #fff;
  border-radius: 50%;
  color: #f5f5f5;
  text-align: center;
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 20px;
  font-weight: bold;
  transition: all 0.3s ease;
}
.round-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 0px 0px 10px rgba(255, 255, 100, 1);
  text-shadow: 0px 0px 10px rgba(255, 255, 100, 1);
}
button.active {
  // background-color: #0077a2;
}
</style>
